<template>
    <v-dialog id="authentication-modal" attach v-model="getModalOpen" :fullscreen="isMobile" max-width="700px"
              scrollable :transition="getTransition">
        <v-card raised v-if="!requestingPassword && !requestComplete" class="auth-modal__card">
            <v-card-title>
                <button v-if="!page" type="button" class="btn-flat-icon--dark" @click="getModalOpen=false">
                    <v-icon large flat>fal fa-times</v-icon>
                </button>
                <button v-else type="button" class="ml-1 mt-1 btn-flat-icon--dark" @click="setUrlHash('')">
                    <v-icon large flat>fal fa-chevron-left</v-icon>
                </button>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="text-xs-center modal-card-text pa-0">
                <div :style="getModalStyle">
                    <div>

                        <!-- <v-btn flat class="email-login__login-button mb-5" :loading="loginEmailRedirecting" id="authBtn-login" @click.native="loginEmailPassword"><p>Login</p></v-btn> -->

                        <!-- <div class="text-xs-center" style="font-size: 1.9em; color: #777">Sign In to WRKPRTY</div> -->
                        <v-btn
                            flat
                            id="authBtn-linkedin"
                            class="linkedin-login-button login-button"
                            dark
                            @click="loginRedirectLinkedin"
                            :loading="loginRedirectingLinkedin"
                        >
                            <div class="linkedin-login-button__text-container">
                                <h1>Sign in with <span style="font-weight: bold">LinkedIn</span></h1>
                                <!-- <p>*Recommended</p> -->
                            </div>
                        </v-btn>
                        <!-- <div class="linkedin-message" v-if="!isMobile">
                            <p>Don't have LinkedIn? Login with Facebook:</p>
                        </div>
                        <div class="linkedin-message" v-else>
                            <p>Don't have LinkedIn?</p><br>
                            <p style="width: 60vw;">Login with Facebook:</p>
                        </div>
                        <v-btn
                            flat
                            id="authBtn-facebook"
                            class="login-button mb-2"
                            @click="loginRedirectFacebook"
                            :loading="loginRedirectingFacebook"
                        >
                            <p>Sign in with&nbsp;<span style="font-weight: bold">Facebook</span></p>
                        </v-btn> -->
                        <!-- <v-btn
                            flat
                            id="authBtn-emailLogin"
                            class="login-button"
                            @click="setUrlHash('register')"
                        >
                            <p>Create account with&nbsp;<span style="font-weight: bold;">Email</span></p>
                        </v-btn>-->
                        <!--<v-btn flat class="login-button-link" @click="setUrlHash('login')"><p>Sign in with email</p></v-btn>-->

                        <!--<<v-btn
                            flat
                            id="authBtn-emailLogin"
                            class="login-button"
                            @click="setModalOpen({prop: 'termsModal', value: true})"
                            >
                            <p>Sign in with email</p></v-btn>
                            -->


                    </div>
                    <!-- <component v-else :is="page"></component> 							@click="setUrlHash('login')"-->
                    <!--	 <component v-else :is="page"></component> -->
                </div>
                <div class="auth-modal__bottom-button-container" v-if="isMobile">
                    <v-btn @click="setModalOpen({ prop: 'termsModal', value: true })"
                           class="auth-modal__bottom-button info--text" flat>Terms
                    </v-btn>
                    <div class="auth-modal__bottom-container__vertical-divider"></div>
                    <v-btn @click="openTermsPrivacy" class="auth-modal__bottom-button info--text" flat>Privacy</v-btn>
                </div>
                <div class="auth-modal__bottom-button-container" v-else>
                    <p class="mt-5 mb-5" style="color: #777; font-size: 0.85em;">By accessing the wrkprty platform you
                        are acknowledging you have read and agree to our <a class="link-blue"
                                                                            @click="setModalOpen({prop: 'termsModal', value: true})">terms
                            of use</a> and <a class="link-blue"
                                              @click="setModalOpen({prop: 'termsModal', value: true})">privacy
                            policy</a>.</p>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios'

import EmailRegistration from '~/components/authentication/EmailRegistration.vue'

import {mapActions, mapGetters} from 'vuex'
import {makeid} from '~/store/util/util'

export default {
    name: 'auth-modal',
    data() {
        return {
            hash: '',
            page: null,
            requestingPassword: false,
            requestComplete: false,
            loginRedirectingFacebook: false,
            loginRedirectingLinkedin: false,
            linkedin_oauth_token: ''
        }
    },
    created() {
        if (document) {
            document.addEventListener('keypress', e => {
                let key = e.which || e.keyCode
                if (key === 13) {
                    if (this.getAuthModalOpen) {
                        this.loginEmailPassword()
                    }
                }
            })
        }
    },
    methods: {
        ...mapActions([
            'setAuthModalOpen',
            'setModalOpen',
            'setAuthRedirect',
            'setToken',
            'setUserSocial',
            'setTermsPage'
        ]),
        openTermsPrivacy() {
            this.setTermsPage('privacypolicy')
            this.setModalOpen({prop: 'termsModal', value: true})
        },
        loginRedirectFacebook() {
            this.loginRedirectingFacebook = true
            window.localStorage.setItem('socialLoginProvider', 'facebook')
            location.href = 'https://www.facebook.com/v2.5/dialog/oauth?response_type=code&' +
                'client_id=' + process.env.VUE_APP_FACEBOOK_CLIENT_ID +
                '&redirect_uri=' + process.env.VUE_APP_HOST_PROTOCOL + process.env.VUE_APP_HOST_URL + 'account/social-login/' +
                '&scope=email,public_profile,user_friends,user_birthday'
        },
        closeRequestComplete() {
            this.setAuthModalOpen(false)
            this.requestComplete = false
        },
        loginRedirectLinkedin() {
            // https://www.linkedin.com/oauth/v2/authorization?client_id=86tgvy4akgb8nf&redirect_uri=http://localhost:4000/account/social-login/
            this.loginRedirectingLinkedin = true
            window.localStorage.setItem('socialLoginProvider', 'linkedin')
            location.href = 'https://www.linkedin.com/oauth/v2/authorization?response_type=code&' +
                'client_id=77mr07009kclvl' +
                '&redirect_uri=' + process.env.VUE_APP_HOST_PROTOCOL + process.env.VUE_APP_HOST_URL + 'account/social-login/' +
                '&scope=r_liteprofile r_emailaddress'
        },
        loginRedirectLinkedinOLD() {
            this.loginRedirectingLinkedin = true
            const userLoginHash = makeid(24)
            window.localStorage.setItem('login_hash', userLoginHash)
            window.localStorage.setItem('socialLoginProvider', 'linkedin')
            axios({
                method: 'post',
                url: '/rest-auth/linkedin/',
                withCredentials: false,
                headers: {
                    'Content-Type': 'application/json'
                },
                transformRequest: (data, headers) => {
                    delete headers['Authorization']
                    delete headers.common['Authorization']
                    return data
                }
            })
                .then(response => {
                    this.linkedin_oauth_token = response.data
                    // window.location.href = this.linkedInAuthUrl
                    this.loginRedirectingLinkedin = false
                    window.location = this.linkedInAuthUrl
                })
                .catch(error => {
                    this.loginRedirectingLinkedin = false
                    console.error('linkedin error')
                    console.error(error)
                })
        }
    },
    computed: {
        ...mapGetters(['getAuthModalOpen', 'getAuthRedirect']),
        linkedInAuthUrl() {
            return (
                'https://www.linkedin.com/uas/oauth/authorize?oauth_token=' +
                this.linkedin_oauth_token
            )
        },
        getTransition() {
            if (this.isMobile) {
                return 'dialog-bottom-transition'
            }
        },
        getModalStyle() {
            if (!this.isMobile) {
                return {
                    'padding': '10px 10px 10px 10px',
                    'display': 'flex',
                    'flex-direction': 'column',
                    'justify-content': 'center',
                    'height': '100%',
                    'min-height': '500px'
                }
            } else {
                return {
                    'min-height': '50vh',
                    'display': 'flex',
                    'flex-direction': 'column',
                    'justify-content': 'center',
                    'height': '100%',
                }
            }
        },
        getModalOpen: {
            get() {
                return this.getAuthModalOpen
            },
            set(val) {
                if (val === false) {
                    history.replaceState({}, document.title, ".")
                } else {
                    this.hash = ''
                    this.page = null
                }
                this.setAuthModalOpen(val)
            }
        },
        isMobile() {
            if (this.$vuetify.breakpoint.name === 'xs') {
                return true
            } else {
                return false
            }
        }
    },
    components: {
        EmailRegistration
    }
}
</script>

<style lang="scss">
.auth-modal__bottom-button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 10px;
    width: 80%;
    margin-left: 10%;
}

.auth-modal__bottom-container__vertical-divider {
    display: inline;
    margin: 0;
    width: 1px;
    height: 15px;
    border-left: 1px solid #AAA;
    margin-top: 1px;
    margin-right: 4px;
}

.auth-modal__bottom-button {
    width: 55px;
    min-width: 55px;

    p {
        font-family: 'Nunito', sans-serif;
        font-weight: 200;
        font-size: 1.1em;
        margin: 0;
    }
}

.linkedin-message {
    min-height: 120px;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 10px 20px 10px;

    p {
        color: #888;
        margin: 0;
    }
}

.login-button {
    border-radius: 0;
    width: 400px;
    min-width: 400px;
    border: 1px solid white !important;
    height: 50px;
    min-height: 50px;
    font-size: 1.0em;

    p {
        color: #BBB !important;
        font-family: 'Nunito', sans-serif;
        font-weight: 200;
        font-size: 1.1em;
        margin: 0;
    }
}

.login-button-link {
    width: 400px;
    min-width: 400px;
    color: white !important;

    p {
        color: #DDD;
        margin: 0;
        font-family: 'Nunito', sans-serif;
        text-decoration: underline;
    }
}

.linkedin-login-button {
    .linkedin-login-button__text-container {
        h1 {
            color: white !important;
            font-size: 1.4em;
            font-weight: 200;
            font-family: 'Nunito', sans-serif;
        }

        p {
            font-size: 0.8em;
            color: white;
            margin: 0;
            font-family: 'Nunito', sans-serif;
        }
    }

    height: 90px;
    min-height: 90px;
}

.auth-modal__card {
    background-color: rgba(0, 0, 0, 0.9) !important;
    color: white !important;
}

.modal-card-text {
    min-height: 70vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.modal {
    overflow: hidden;
}

@media screen and (max-width: 600px) {
    .login-button {
        width: 90vw;
        min-width: 90vw;
    }
    .login-button-link {
        width: 90vw;
        min-width: 90vw;
    }
}

@media screen and (max-width: 600px) and (max-height: 500px) {
    .linkedin-message {
        width: 90vw;
        font-size: 0.8em;
        margin-left: 5vw;
    }
    .login-button {
        height: 40px;
        min-height: 40px;
    }
    .linkedin-login-button {
        padding: 0;
        height: 60px;
        min-height: 60px;
    }
}
</style>
